import { QuestionType } from '../../models';
import { componentMapping } from '../../models/contentMapping';

const isExtendedComponentType = <ExtendedComponentTypes>(
  extendedComponents: Record<
    keyof ExtendedComponentTypes,
    React.ComponentType<any>
  >,
  type: QuestionType | keyof ExtendedComponentTypes
): type is keyof ExtendedComponentTypes => {
  for (const key in extendedComponents) {
    if (type === key) {
      return true;
    }
  }
  return false;
};

const isInternalComponentType = <ExtendedComponentTypes>(
  internalComponents: Record<QuestionType, React.ComponentType<any>>,
  type: QuestionType | keyof ExtendedComponentTypes
): type is QuestionType => {
  for (const key in internalComponents) {
    if (type === key) {
      return true;
    }
  }
  return false;
};

export const getQuestionComponent = <ExtendedComponentTypes>(
  type: QuestionType | keyof ExtendedComponentTypes,
  extendedComponents?: Record<
    keyof ExtendedComponentTypes,
    React.ComponentType<any>
  >
): React.ComponentType<any> | null => {
  if (extendedComponents && isExtendedComponentType(extendedComponents, type)) {
    return extendedComponents[type];
  }

  if (componentMapping && isInternalComponentType(componentMapping, type)) {
    return componentMapping[type];
  }

  return null;
};
